export abstract class Theme {
  abstract isDark: boolean;
}
